import { PageLoader } from 'components';
import { useQuery } from 'core/hooks';
import {
    ArticleMode,
    ArticleModeRouteNames,
    ArticleModeRubriqueTypes,
    RubriqueForm,
    toRubriqueForm,
} from 'core/models';
import { rubriqueService } from 'core/services';
import React from 'react';
import { useHistory, useParams } from 'react-router';
import ActualiteCategorieForm from '../Form';

type Props = {
    mode: ArticleMode;
};

const ActualiteRubriqueEdit: React.FC<Props> = ({ mode }) => {
    const history = useHistory();
    const { id } = useParams<any>();

    const { data, loading } = useQuery(rubriqueService.getRubrique, id);

    const onSubmit = (rubrique: RubriqueForm) => {
        rubriqueService
            .editRubrique(id, rubrique)
            .then(() => history.push(`/${ArticleModeRouteNames[mode]}/rubriques`));
    };

    if (loading || !data) {
        return <PageLoader loading />;
    }

    return (
        <ActualiteCategorieForm
            mode={mode}
            defaultValues={toRubriqueForm(data, ArticleModeRubriqueTypes[mode])}
            onEdit={onSubmit}
        ></ActualiteCategorieForm>
    );
};

export default ActualiteRubriqueEdit;
